module.exports = __webpack_public_path__ + "img/f6.a15d952f.jpg";